import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/live';
import LinkIcon from '../../../../assets/icons/LinkIcon';
import {TEticketSubscriptionTicket} from '../../../../redux/eTicket/eTicket.type';
import {openUrl} from '../../TransactionCard/transactionCardUtils';
import MemberDateBox from '../memberDateBox/MemberDateBox';
import * as css from './MemberTicketsSheet.css';

interface MemberTicketRowProps {
    ticket: TEticketSubscriptionTicket;
}

/* The tickets taken for one show in one order — opens the regular entrance ticket created for them.
   The venue and how many tickets were taken read as one line under the show's name. */
function MemberTicketRow({ticket}: MemberTicketRowProps) {
    const {t} = useTranslation('eTicket');
    const {qid, timeStart, title, location, url, ticketsCount} = ticket;
    const countLabel = ticketsCount
        ? (ticketsCount === 1 ? t('ticketsCountOne') : t('ticketsCountMany', {count: ticketsCount}))
        : '';
    const meta = [location, countLabel].filter(Boolean).join(' · ');

    return (
        <css.item data-cy={`member-ticket-row-${qid}`}>
            <MemberDateBox ts={timeStart ?? undefined} />
            <css.text>
                <css.name>{title}</css.name>
                {meta && <css.meta>{meta}</css.meta>}
            </css.text>
            {url && (
                <Button
                    variant="subtle"
                    size="chip"
                    iconEnd={<LinkIcon color="currentColor" width={14} height={14} />}
                    onClick={() => openUrl(url)}
                    data-cy={`member-ticket-row-go-${qid}`}>
                    {t('goToTicket')}
                </Button>
            )}
        </css.item>
    );
}

export default MemberTicketRow;
